module.exports = __webpack_public_path__ + "static/media/warning-icon.385dcfb3.svg";